<template>
    <section id="product-form" class="product-form">
        <div class="container">
            <b-form>
                <div class="container-form">
                    <!-- <h3 class="tap-name">
                        {{ $t('form.personal_info') }}
                    </h3>
                    <div class="line"></div>-->
                    <div class="row my-row">
                        <div class="col-lg-6">
                            <b-form-group id="name" :label="$t('form.name')">
                                <b-form-input
                                    id="name"
                                    v-model="name"
                                    :placeholder="$t('form.name')"
                                ></b-form-input>
                                <div class="error-section" v-if="v$.name.$error">
                                    <b-icon icon="exclamation-triangle"></b-icon>
                                    <span class="error">{{ v$.name.$errors[0].$message }}</span>
                                </div>
                            </b-form-group>
                        </div>
                        <div class="col-lg-6">
                            <b-form-group id="email" :label="$t('form.email')">
                                <b-form-input
                                    id="email"
                                    v-model="email"
                                    :placeholder="$t('form.email')"
                                ></b-form-input>
                                <div class="error-section" v-if="v$.email.$error">
                                    <b-icon icon="exclamation-triangle"></b-icon>
                                    <span class="error">{{ v$.email.$errors[0].$message }}</span>
                                </div>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="row my-row">
                        <div class="col-lg-6">
                            <b-form-group id="phone" :label="$t('form.phone')">
                                <b-form-input
                                    id="phone"
                                    v-model="phone"
                                    :placeholder="$t('form.phone')"
                                ></b-form-input>
                                <div class="error-section" v-if="v$.phone.$error">
                                    <b-icon icon="exclamation-triangle"></b-icon>
                                    <span class="error">{{ v$.phone.$errors[0].$message }}</span>
                                </div>
                            </b-form-group>
                        </div>
                        <div class="col-lg-6">
                            <b-form-group
                                id="company_name"
                                :label="$t('form.company_name')"
                            >
                                <b-form-input
                                    id="company_name"
                                    v-model="company_name"
                                    :placeholder="$t('form.company_name')"
                                ></b-form-input>
                                <div class="error-section" v-if="v$.company_name.$error">
                                    <b-icon icon="exclamation-triangle"></b-icon>
                                    <span class="error">{{ v$.company_name.$errors[0].$message }}</span>
                                </div>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="row my-row">
                        <div class="col-lg-6">
                            <b-form-group
                                id="message"
                                :label="$t('form.notes')"
                            >
                                <b-form-textarea
                                    id="message"
                                    v-model="message"
                                    :placeholder="$t('form.notes_placeholder')"
                                    style="height:120px"
                                ></b-form-textarea>
                                <div class="error-section" v-if="v$.message.$error">
                                    <b-icon icon="exclamation-triangle"></b-icon>
                                    <span class="error">{{ v$.message.$errors[0].$message }}</span>
                                </div>
                            </b-form-group>
                        </div>
                        <div class="col-lg-6">
                            <b-form-group
                                id="product_type"
                                :label="$t('form.service')"
                            >
                                <b-form-select
                                    v-model="serviceName"
                                    class="form-control"
                                    style="margin-top: 2px;"
                                    aria-placeholder="hhhh"
                                    multiple 
                                >
                                    <b-form-select-option
                                        :value="item.title"
                                        v-for="(item, index) in serviceList"
                                        :key="index"
                                    >{{item.title}}</b-form-select-option>
                                </b-form-select>
                                <div class="error-section" v-if="v$.serviceName.$error">
                                    <b-icon icon="exclamation-triangle"></b-icon>
                                    <span class="error">{{ v$.serviceName.$errors[0].$message }}</span>
                                </div>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <vue-recaptcha
                                ref="recaptcha"
                                sitekey="6LeRM6ooAAAAAMlUH4RzG-jJlLooglnsK5aOgor-"
                                style="margin-top: 10px;"
                                @verify="verify"
                                @expired="expired"
                                :load-recaptcha-script="true"
                            />
                        </div>
                    </div>
                    <div style="text-align:justify">
                        <button
                            v-on:click="submitForm"
                            type="button"
                            class="my-button"
                            :disabled="submit && !response"
                        >
                            {{ $t('form.submit') }}
                            <b-spinner
                                v-if="submit && !response"
                                label="Text Centered"
                                style="margin: 0px 5px"
                            ></b-spinner>
                        </button>
                    </div>
                </div>
                <b-modal v-model="modalShow" ok-only style="margin-top: 100px">
                    <p
                        style="text-align: center;margin-top: 15px;font-size: 18px;"
                    >{{ $t('success_message') }}</p>
                </b-modal>
            </b-form>
        </div>
    </section>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, email, helpers, minLength, url } from '@vuelidate/validators'
import VueRecaptcha from "vue-recaptcha"


export default {
    name: "ProductForm",
    setup() {
        return { v$: useVuelidate() }
    },
    components: {
        VueRecaptcha
    },
    data() {
        return {
            name: '',
            email: '',
            phone: '',
            company_name: '',
            message: '',
            serviceList: [],
            serviceName: [],
            submit: false,
            response: false,
            modalShow: false,
            my_verify: false
        };
    },
    validations() {
        return {
            name: {
                required: helpers.withMessage('This field is required', required)
            },
            email: {
                required: helpers.withMessage('This field is required', required),
                email: helpers.withMessage('Please enter valid email', email)
            },
            phone: {
                required: helpers.withMessage('This field is required', required),
                minLength: helpers.withMessage('Please enter valid phone number', minLength(10))
            },
            company_name: {
                required: helpers.withMessage('This field is required', required),
            },
            message: {
                required: helpers.withMessage('This field is required', required)
            },
            serviceName: {
                required: helpers.withMessage('This field is required', required)
            }
        }
    },
    methods: {
        verify() {
            this.my_verify = true
        },
        expired() {
            this.my_verify = false
            this.$refs.recaptcha.reset();
        },
        submitForm() {
            this.v$.$validate();
            if (!this.v$.$error && this.my_verify) {
                this.submit = true
                this.sendData()
            }
        },
        sendData() {
            const formData = new FormData()
            formData.append('fullName', this.name)
            formData.append('phone', this.phone)
            formData.append('email', this.email)
            formData.append('companyName', this.company_name)
            formData.append('details', this.message)
            this.serviceName.forEach((item, index) => {
                formData.append(`serviceName[${index}]`, item)
            });
            console.log(formData)
            for (var pair of formData.entries()) {
                console.log(pair)
            }
            this.axios.post(this.$store.state.url + "service-form", formData)
                .then((res) => {
                    console.log(res)
                    this.response = true
                    if (res.status == 200) {
                        this.modalShow = true
                        this.email = ''
                        this.phone = ''
                        this.name = ''
                        this.company_name = ''
                        this.message = ''
                        this.serviceName = []
                        this.v$.$reset()
                    }
                })
                .catch(error => {
                    this.response = false
                    this.submit = false
                })
        },
        getService() {
            this.axios.get(this.$store.state.url + "services")
                .then(res => {
                    this.serviceList = res.data.list
                    console.log(this.serviceList)
                });
        },
    },
    mounted() {
        this.getService()
    }
};
</script>

<style lang="scss">
.product-form {
    padding: 50px;
}

.product-form .form-group {
    justify-content: space-between;
    margin: 20px 0px;
}

.product-form .container-form {
    margin-right: 4%;
    margin-left: 4%;
    margin-top: 30px;
}

.product-form .form-control,
.product-form .custom-file {
    outline: none;
    border: 1px solid rgb(230, 230, 230);
    border-radius: 4px;
    height: 50px;
    margin-top: 10px;
    background-color: #bebebe11;
    transition: all 0.5s ease;
}

.product-form .form-control:focus {
    box-shadow: none;
    border: 1px solid var(--main-blue);
    background: #fff;
    transition: all 0.5s ease;
    box-shadow: 0px 0px 6px #24487961;
}

.product-form .d-block {
    color: var(--main-blue);
    text-align: justify;
    font-size: 18px;
}

.product-form .line {
    border-bottom: 1px solid #bebebe;
    margin-top: 20px;
}

.product-form .tap-name {
    text-align: justify;
    color: var(--main-blue);
    font-weight: 800;
}

@media (min-width: 992px) {
    .product-form .my-row {
        margin-top: 20px;
    }
}

.product-form .error {
    color: #b61532;
    margin: 5px;
}

.product-form .bi-exclamation-triangle {
    color: #b61532;
    font-size: 18px;
}

.product-form .error-section {
    margin-top: 10px;
    text-align: justify;
}

//button
.product-form .my-button {
    position: relative;
    color: var(--main-blue);
    font-size: 16px;
    font-weight: 800;
    text-decoration: none;
    margin: 30px 0;
    border: 1px solid var(--main-blue);
    padding: 12px 30px;
    overflow: hidden;
    transition: 0.6s all ease;
    background: transparent;
    border-radius: 10px;
    z-index: 100000;
}

.product-form .my-button::before {
    background: var(--main-blue);
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
    transition: all 0.6s ease;
}

.product-form .my-button:hover {
    color: #fff;
}

.product-form .my-button::before {
    width: 0%;
    height: 101%;
}

.product-form .my-button:hover::before {
    width: 100%;
}

////
.product-form .bv-no-focus-ring {
    text-align: justify;
    margin-top: 30px;
}

.product-form .custom-control-label::before {
    width: 25px;
    height: 25px;
    margin-left: -15px;
    margin-top: -9px;
}

.product-form .custom-control-label {
    margin-left: 15px;
    cursor: pointer;
}

.product-form .custom-control-label::after {
    top: -6px;
    left: -40px;
    width: 26px;
    height: 26px;
}

.product-form .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: var(--main-blue);
    background-color: var(--main-blue);
    box-shadow: 0px 0px 6px #24487961;
}

//date

.product-form .b-form-btn-label-control.form-control {
    height: 50px;
}

.product-form .b-form-btn-label-control.form-control > .form-control {
    text-align: justify;
    margin-top: 5px;
}

.product-form .bi-calendar,
.product-form .bi-calendar-fill {
    color: var(--main-blue);
}

.btn-outline-primary,
.btn-outline-primary:hover,
.btn-outline-primary:active,
.btn-outline-primary:visited,
.btn-outline-primary:focus {
    background-color: var(--main-blue) !important;
    border-color: var(--main-blue) !important;
}

.btn-outline-primary {
    color: #fff !important;
}

.btn-outline-primary:focus,
.btn-outline-primary.focus {
    box-shadow: 0 0 0 0.6px #24487961 !important;
}

.form-control.focus {
    border: 1px solid var(--main-blue) !important;
    box-shadow: 0px 0px 6px #24487961 !important;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
    background-color: var(--main-blue) !important;
    box-shadow: 0px 0px 6px #24487961 !important;
}

.b-calendar-grid-help {
    display: none !important;
}

//file
.custom-file-label {
    height: 50px !important;
    background-color: #bebebe11 !important;
    border: none !important;
    cursor: pointer;
}

.form-file-text {
    color: #6c757d !important;
    font-size: 16px !important;
    margin-top: 5px;
}

.b-form-file {
    margin-top: 0px !important;
}

.custom-file-input ~ .custom-file-label[data-browse]::after {
    height: 50px;
}

.custom-file-label::after {
    line-height: 35px !important;
}
</style>